import { render, staticRenderFns } from "./empty-content.vue?vue&type=template&id=a7128f52&"
import script from "./empty-content.vue?vue&type=script&lang=js&"
export * from "./empty-content.vue?vue&type=script&lang=js&"
import style0 from "./empty-content.vue?vue&type=style&index=0&id=a7128f52&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports